module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAV1JREFUSIndVct1wjAQnFEaSAmUkA4QfcQ+4kduqQC5guTm5xxxISgdUAoNmMkBbGxs2YKXSzJHfWZ2drUr4K+Dg5WqsNTT9l4iUR4AkGR5d930ycstZfb3kgMABUfBoSoDwVXllrtS4QMRaDkK2yyZwaEbi32Cwk4GkGQ5QN9NcStA0QL0k9HJ7Ck47r6i0zh0ECSHE+GUZgSAWJF5gaqwDXmTPqXrVaxIhAOz7JI3EOsckO0W9CGBc21GkGz8ZM1iBQBZ4PQdDADmY8pFXJFD0pTHCc9TnR8hQA+Y5eiO4OZuRzkYrUObFh6B8IuaFbi+ln4HU2YvwoE4QngJ3Z93kGy82B9kvWilBXDtjfsFACDJ8kaEu1IAIFO/tzUgDo876IqkGcXTSul6hde3z0uKFo2LM2Tbv6GHqrC/N66vHBwcaJ/efJcOIXs7Vka+zEshQyNiip51fh4h/wk/sLyo8jCtlOUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/35.png
// module id = VSS5
// module chunks = 1